import script from "./UserInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./UserInfo.vue?vue&type=script&setup=true&lang=js"

import "./UserInfo.vue?vue&type=style&index=0&id=6edd5e47&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6edd5e47"]])

export default __exports__